
import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as PlusSquare } from "bootstrap-icons/icons/plus-square.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../components/utils/CustomStyles";
import { handleError } from "../../components/utils/AuthenticationCheck";
import formatDate from "../../components/utils/DateFormatter";
import AxiosApiCall from "../../api/AxiosApiCall";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";

const ClusterLocationList = () => {
    const [clusterLocation, setClusterLocation] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [confirmationLoading, setConfirmationLoading] = useState(false);
    const { permissions } = useContext(AuthContext);
    // console.log("permissions", permissions);

    const navigate = useNavigate();
    //axios api encryption call
    const axios = AxiosApiCall();

    useEffect(() => {
        const fetchAllClusterLocation = async () => {
            setLoading(true);
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                const token = authData?.token;
                if (!token) {
                    throw new Error("No access token found.");
                }

                const response = await axios.get(ApiServices.getClusterLocation, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                });


                //  console.log("these are all the  clusterLocation", response.data);
                const { status, message, data } = response.data;
                if (status === 200) {
                    setClusterLocation(data);
                    toast.success(message, { toastId: "clusterLocation-fetch-success" });
                } else {
                    handleError({ response: { status, data: { message } } }, navigate);
                }
            } catch (error) {
                handleError(error, navigate);
            } finally {
                setLoading(false);
            }
        };

        fetchAllClusterLocation();
    }, []);


    // Handle Delete Confirmation
    const handleDeleteConfirmation = (addressId) => {
        setConfirmationLoading(true);
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            setConfirmationLoading(false);
            if (result.isConfirmed) {
                handleDeleteProduct(addressId);
            }
        });
    };

    // Handle Product Deletion
    const handleDeleteProduct = async (addressId) => {
        const formData = {
            address_id: addressId,
        };
        // console.log("this is my form data for delete", formData);
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) {
                throw new Error("No access token found.");
            }
            const response = await axios.delete(ApiServices.deleteClusterLocation, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                data: formData,
                withCredentials: true,
            });

            const updatedClusterLocation = clusterLocation.filter(
                (clusterLocation) => clusterLocation.id !== addressId
            );
            setClusterLocation(updatedClusterLocation);

            const { status, message } = response.data;
            if (status === 200) {
                toast.success(message, { toastId: "clusterLocation-delete-success" });
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };



    const handleFilter = (e) => {
        setFilterText(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle);
    };



    // Define Expandable Component for Actions
    const ExpandableComponent = ({ data }) => (
        <div className="flex justify-content-start">
            {/* am using admin permission for this module cos we dont have cluster permission */}
            {permissions.some(permission => permission.name === 'admin.view') && (
                <Link
                    to="/admin/cluster/location/details"
                    state={{ clusterLocation: data }}
                    className="mx-2 my-2 group"
                >
                    <Eye className="w-5 h-5 text-darkGreen3" />
                </Link>
            )}
            {permissions.some(permission => permission.name === 'admin.edit') && (
                <Link
                    to="/admin/cluster/location/update"
                    state={{ clusterLocation: data }}
                    className="mx-2 my-2 group"
                >
                    <PencilSquare className="w-5 h-5 text-dash4" />
                </Link>
            )}
            {/* this permission does not exist admin.delete so i will use admin.create  for now*/}
            {permissions.some(permission => permission.name === 'admin.create') && (
                <div className="mx-2 my-2 group relative">
                    <button
                        onClick={() => handleDeleteConfirmation(data.id)}
                        disabled={confirmationLoading}
                    >
                        <Trash className="w-5 h-5 text-dash3 " />
                    </button>
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash3 text-xs px-2 py-1 rounded">
                        Delete
                    </div>
                </div>
            )}
        </div>
    );

    // Function to format permission text
    const formatText = (text) => {
        let formattedText = text.replace(/_/g, " ");
        formattedText = formattedText
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
        return formattedText;
    };

    const columns = [

        {
            name: "Address",
            selector: (row) => formatText(row.address),
            sortable: true,
            width: "600px",
        },
        {
            name: "Amount",
            selector: (row) => row.amount? 
            CurrencyFormatter(row.amount) : "0.00",
            sortable: true,
            width: "200px",
        },
        {
            name: "Date",
            selector: (row) => formatDate(row.created_at),
            sortable: true,
            width: "300px",
        },
    ];


    const filteredItems = clusterLocation.filter((item) => {
        for (let key in item) {
            if (
                typeof item[key] === "string" &&
                item[key].toLowerCase().includes(filterText.toLowerCase())
            ) {
                return true;
            }
        }
        return false;
    });

    const data = filteredItems.map((clusterLocation) => ({
        address: clusterLocation.address ? clusterLocation.address : "NOT AVAILABLE",
        amount: clusterLocation.amount ? clusterLocation.amount : "0.00",
        created_at: clusterLocation.created_at,
        id: clusterLocation.id
    }));

    // Sort data based on creation date
    const sortedData = [...data].sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA;
    });

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section
                        className="w-full pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Cluster
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Point</p>
                                </li>
                            </ol>
                        </nav>
                    </section>
                    <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
                        <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
                            <input
                                type="search"
                                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                                placeholder="Search"
                                value={filterText}
                                onChange={handleFilter}
                            />
                        </div>
                        {permissions.some(permission => permission.name === 'admin.create') && (
                            <Link
                                to="/admin/cluster/location/create"
                                className="m-1 w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                            >
                                <span className="flex justify-center sm:justify-start mx-2">
                                    <PlusSquare className="mr-2" />
                                    Create Cluster Point
                                </span>
                            </Link>
                        )}
                    </div>
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (

                        <DataTable
                            columns={columns}
                            data={sortedData}
                            pagination
                            striped
                            highlightOnHover
                            customStyles={CustomStyles}
                            noDataComponent={<div>No Cluster point found</div>}
                            expandableRows
                            expandableRowsComponent={ExpandableComponent}
                        />
                    )}
                </div>
            </MainLayouts>
        </div>
    );
};

export default ClusterLocationList;


